import {Link, useLocation} from "react-router-dom";

const HOME_URL = "/home";
const SLIDESHOW_URL = "/slideshow";
const CELEBRATIONS_URL = "/celebrations";

interface NavigationToggleProps {
    isDarkTheme?: boolean;
}

export const NavigationToggle = ({ isDarkTheme = false }: NavigationToggleProps) => {
    const {pathname} = useLocation();

    const linkBaseStyles = "px-2 md:px-4 py-2 rounded-full font-medium transition-colors text-sm md:text-base";
    const activeLinkStyles = isDarkTheme ? "bg-white text-blue-950 hover:bg-gray-100" : "bg-blue-950 text-white hover:bg-blue-800";
    const inactiveLinkStyles = isDarkTheme ? "text-gray-300 hover:text-white" : "text-gray-600 hover:text-gray-900";

    return (
        <nav className="flex gap-1 md:gap-4 items-center">
            <Link to={HOME_URL}
                  className={`${linkBaseStyles} ${pathname === HOME_URL ? activeLinkStyles : inactiveLinkStyles}`}>
                Home
            </Link>
            <Link
                to={SLIDESHOW_URL}
                className={`${linkBaseStyles} ${pathname === SLIDESHOW_URL ? activeLinkStyles : inactiveLinkStyles}`}
            >
                <span className="sm:hidden">Show</span>
                <span className="hidden sm:inline">Slideshow</span>
            </Link>
            <Link
                to={CELEBRATIONS_URL}
                className={`${linkBaseStyles} ${
                    pathname === CELEBRATIONS_URL ? activeLinkStyles : inactiveLinkStyles
                }`}
            >
                <span className="sm:hidden">🎉</span>
                <span className="hidden sm:inline">Celebrations</span>
            </Link>
        </nav>
    );
};
